import { AlertDialog, useDialog as useDaxDialog } from '@global-dax-ad-platform/dax-components';
import { Button, Typography } from '@global-engineering-shared/gweb-material-ui';

import { FrameFileType } from 'features/DataManagement/components/FrameServiceButtons/frameFileType';
import { useStyles } from 'features/DataManagement/components/FrameServiceButtons/FrameServiceButtons.styles';
import { useDownloadDataFile } from 'hooks/useDownloadFile';
import { FRAME_SERVICE_API_URL } from 'utils/defaults';

export interface IFrameServiceButtonsProps {
  uploadInProgress: boolean;
}

const FrameServiceButtons = ({ uploadInProgress }: IFrameServiceButtonsProps) => {
  const { downloadFile, isDataLoading } = useDownloadDataFile();
  const { openDialog: openDaxDialog } = useDaxDialog();

  const handleDownloadClick = async (fileType: FrameFileType) => {
    const url = `${FRAME_SERVICE_API_URL}/${fileType.toLowerCase()}`;
    const filename = `${fileType}.csv`;
    await downloadFile(url, filename);
  };

  const classes = useStyles();

  const shouldShowModal = uploadInProgress || isDataLoading;
  const dismissDialog = () => {};

  return (
    <div className={classes.buttonDiv}>
      <AlertDialog
        dialogId={'dataManagmentModal'}
        hideCancelButton={true}
        content={{
          title: 'Entity sync in progress',
          main: (
            <>
              <Typography color="textPrimary" variant="body2">
                Entity sync in progress, please wait for SSP to resolve
              </Typography>
            </>
          ),
        }}
        action={{ label: 'Continue', onClick: dismissDialog }}
      />
      <Button
        onClick={() =>
          shouldShowModal
            ? openDaxDialog('dataManagmentModal')
            : handleDownloadClick(FrameFileType.FRAMES)
        }
      >
        Download Frames
      </Button>
      <Button
        onClick={() =>
          shouldShowModal
            ? openDaxDialog('dataManagmentModal')
            : handleDownloadClick(FrameFileType.FRAME_GROUPS)
        }
      >
        Download Frame Groups
      </Button>
    </div>
  );
};

export default FrameServiceButtons;
